export default __webpack_public_path__ + "static/media/suite-montanha1-3.d7eeefff.webp";